import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { generateFilterStateKey } from '@atlassian/notification-common';
import resolveLoadingStates from '../../../../use-notification-list-filters-store/utils/resolve-loading-states';
import { getFilterStateOrDefaultByKey } from '../../../../utils/build-filter-state';
import { mergeGroups } from './utils';
export var updateGroups = function updateGroups(payload) {
  return function (_ref) {
    var getState = _ref.getState,
      setState = _ref.setState;
    var filterLocalState = getState();
    var filterStateKey = generateFilterStateKey(payload.filters);
    var filterState = getFilterStateOrDefaultByKey(filterLocalState.filterStates, filterStateKey);
    if (filterState.fetchingDisabled) {
      return;
    }
    var fetchState = resolveLoadingStates(payload.loadingStates, filterState.fetchState);
    var currentGroups = getState().groups;
    var updateGroups = mergeGroups(currentGroups, payload.groups);
    setState({
      filterStates: _objectSpread(_objectSpread({}, filterLocalState.filterStates), {}, _defineProperty({}, filterStateKey, _objectSpread(_objectSpread({}, filterState), {}, {
        fetchState: fetchState,
        continuationToken: payload.continuationToken
      }))),
      groups: updateGroups
    });
  };
};